(() => {
  'use strict';

  if (window.dancingOaksTitleRelevanceSearch) return;
  window.dancingOaksTitleRelevanceSearch = true;

  const searchFormSelector = 'form[data-title-relevance-search]';

  const getSearchInput = (form) => form?.querySelector('input[type="search"]');

  const buildSearchUrl = (form) => {
    const input = getSearchInput(form);
    const query = input?.value.trim();
    if (!query) return null;

    const url = new URL(form.action || window.location.pathname, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('options[unavailable_products]', 'show');
    return url;
  };

  const openSearchResults = (form) => {
    const url = buildSearchUrl(form);
    if (!url) return false;
    window.location.assign(url.toString());
    return true;
  };

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter') return;

      const input = event.target.closest?.(`${searchFormSelector} input[type="search"]`);
      if (!input) return;

      const form = input.closest(searchFormSelector);
      event.preventDefault();
      event.stopImmediatePropagation();
      openSearchResults(form);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest?.(searchFormSelector);
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openSearchResults(form);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const seeAllLink = event.target.closest?.('.omega__see-all');
      if (!seeAllLink) return;

      const focusedForm = document.activeElement?.closest?.(searchFormSelector);
      const headerForm = document.querySelector('[data-header-search-form]');
      const form = focusedForm || headerForm;
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openSearchResults(form);
    },
    true
  );

})();
